<template lang="pug">
    v-container(fluid)
      //- Dailogs
      v-dialog(transition="dialog-bottom-transition" fullscreen v-model='dialogOrder' v-if="dialogOrder" )
        order-modal(:shop="shopSelected" @closeModalOrder="dialogOrder=false")
      //- Content
      v-row(v-if="stores.length > 0").store-card__container
        v-col(cols="12" sm="6" v-for="(store, i) of stores" :class="i % 2 === 0 && !isMobile ? 'divider':''")
          v-row
            v-card(flat color='transparent' @click="selectShop(store)" :key="store.data.name").store-card
              .d-flex.flex-no-wrap.justify-start(style="width: 100%")
                .store-card__image
                  v-img(:src="store.data.img.imageInput1 ? store.data.img.imageInput1 :tenderBg ")
                div
                  v-card-title(v-text="store.data.name").pt-1
                  v-card-subtitle(style="font-size: 12px").mt-1.pb-1
                    span( v-for="category of store.data.categories.slice(0,2)").mr-1
                      | {{category.name}} ,
                    v-row
                      v-btn(v-if="isMobile" @click.prevent.stop="getTopProducts(store)" text small color="primary" :loading="store.data.loadingTopProds") top más vendidos
                  v-card-text().text--primary
                    div(v-if="store.data.domicileValue")
                      b(style="font-size: 13px;") Domicilio: {{store.data.domicileValue | numberFormat}}
                      b.ml-5(style="font-size: 13px;") 30-45 min
            v-btn(v-if="!isMobile").d-flex.align-self-center(@click="getTopProducts(store)" text small color="primary" :loading="store.data.loadingTopProds") top más vendidos
          .container.card-products(v-if="store.data.topSales")
            template(v-for="(item, index) in store.data.topSales.slice(0,4)")
              v-card(:key="item.id").product-card.ma-2
                p.product-card__tag(style=" margin-bottom: 0px;") {{item.name}}
                .product-card__content
                  .product-card__background
                      v-img(:src="item.pictures.imageInput1 === '' ? allCategorys : item.pictures.imageInput1" width="100" height="100" contain)
                  .product-card__money-tag
                    span.product-card__money-tag__sign $
                    span {{item.price.sale | numberFormat}}
                div
                  .product-card__addBtn.mt-2(@click="addToCart(item, store)")
                    .product-card__addBtn-container
                      span +
          v-row.justify-center(v-if="store.data.topSales && store.data.topSales.length === 0 && !store.data.loadingTopProds")
            p No hay productos para mostrar
          v-col(v-if="store.data.loadingTopProds" cols="12" style="overflow: hidden").text-center
            v-row.my-2
              v-skeleton-loader( v-for='i in 4' max-width="110px" max-height='110px' width='100%' height='110px' type="card").mx-auto.my-2
      v-row(v-if="isLoading")
        v-col(cols="12").text-center
          v-card-text.text-center.font-weight-light
            v-row(v-for='i in 3')
              v-col(cols="12" md="6")
                v-skeleton-loader(  width='100%' type="list-item-avatar-two-line").mx-auto
              v-col(cols="12" md="6")
                v-skeleton-loader(  width='100%' type="list-item-avatar-two-line").mx-auto
      v-row(v-if="!isLoading")
          v-col(cols="12").text-center
              v-card-text(v-if="stores.length === 0").text-center.font-weight-light
                | No hay tiendas cerca de tu ubicación en esta categoria.
              v-card-text(v-if="stores.length === 0 && category !== 'Todas'").body-1.text-center.font-weight-light
                | ¿Te gustaria ser el primero en tener una tienda con la categoria {{category}}?
              v-card-text(v-else-if="category !== 'Todas'").body-1.text-center.font-weight-light
                | ¿Te gustaria crear una tienda en la categoria {{category}}?
              v-card-text(v-else).body-1.text-center.font-weight-light
                | ¿Te gustaria crear una tienda?
              v-col(cols="12").text-center
                  v-btn.mr-0.gradient-color(small @click="user ? $router.push({ name: 'Crear Tienda', params: { category }}) : $router.push('/pages/register')")
                    | Crear
                    v-img.ml-1(src="@/assets/icons/icon-store.png" width="20")
      // Cards
      v-row(no-gutters)
        v-col(cols="3" v-for="card in cards" style="padding: 0.8px")
          v-card
            v-img.white--text.align-end(:src="card.src")
</template>

<script>
  import tenderBg from '@/assets/images/background-tender.png'
  import card1 from '@/assets/images/storelist/capa-47.png'
  import card2 from '@/assets/images/storelist/capa-48.png'
  import card3 from '@/assets/images/storelist/capa-49.png'
  import card4 from '@/assets/images/storelist/capa-51.png'
  import allCategorys from '@/assets/icons/products.png'
  import moment from 'moment'
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })
  export default {
    components: {
      OrderModal: () => import('@/views/marketplace/components/OrderModal'),
    },
    filters: {
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      moneyFormat: function (value) {
        return formatter.format(value).slice(3)
      },
    },
    props: {
      category: String,
      stores: {
        type: Array,
        default () {
          return []
        },
      },
    },
    data () {
      return {
        tenderBg: tenderBg,
        shopSelected: {},
        allCategorys: allCategorys,
        dialogOrder: false,
        cards: [
          { src: card1 },
          { src: card2 },
          { src: card3 },
          { src: card4 },
        ],
      }
    },
    computed: {
      user () {
        return this.$store.state.users.user
      },
      /* category () {
        // console.log('algo 2', this.$route.params.id)
        // console.log('route', this.$route)
        if (this.$route.params.id !== undefined) return this.$route.params.id.split('_').join(' ')
        return 'Arte'
      }, */
      /* stores () {
        return this.$store.getters['storefront/getStoreCategorie'].filter(el => el.data.status === 'active')
      }, */
      isLoading () {
        return this.$store.getters['storefront/isLoading']
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    watch: {
      category (val) {
        this.fetch()
      },
    },
    mounted () {
      const vm = this
      vm.fetch()
      // console.log(vm.stores)
    },
    methods: {
      getTopProducts (store) {
        const vm = this
        store.data.loadingTopProds = true
        this.$forceUpdate()
        const info = {
          dates: {
            from: moment().subtract(29, 'days').format('YYYY-MM-DD'),
            to: moment().add(1, 'days').format('YYYY-MM-DD'),
          },
          userId: store.data.uid,
          shopId: store.data.id,
          context: '',
        }
        vm.$store.dispatch('summary/top20Products', info).then(res => {
          store.data.loadingTopProds = false
          // console.log('prodstop20', res)
          if (res) {
            store.data.topSales = res
          } else {
            store.data.topSales = []
          }
          vm.$forceUpdate()
        })
      },
      fetch () {
        const vm = this
        const storeList = vm.$store.state.storefront.store_list
        if (storeList.length === 0) {
          vm.$store.dispatch('storefront/loadStores').then(() => {
            vm.$store.dispatch('storefront/setCategorieStore', vm.category).then(function () {
              //
            })
          }, function (err) {
            console.log(err, 'Permision denied error')
          })
        } else {
          vm.$store.dispatch('storefront/setCategorieStore', vm.category).then(function () {
            //
          })
        }
      },
      selectShop (store) {
        const vm = this
        /* if (vm.isMobile && store.data.id) {
          // console.log(store)
          vm.$router.replace('/shop/' + store.data.subdomain)
        } else { */
        vm.shopSelected = {
          category: store.data.categories,
          data: {
            ...store.data,
          },
          id: store.data.id,
        }
        // console.log(vm.shopSelected)
        vm.dialogOrder = true
        // }
      },
      getDataCart () {
        this.arrCart = this.$store.getters['pos/getCart']
        this.totalProducts = 0
        this.totalPrice = 0
        for (let i = 0; i < this.arrCart.length; i++) {
          for (let j = 0; j < this.arrCart[i].inventory.length; j++) {
            this.totalPrice = (parseFloat(this.totalPrice) + (parseFloat(this.arrCart[i].inventory[j].data.price.sale)) * (parseFloat(this.arrCart[i].inventory[j].amount))).toFixed(0)
            this.totalProducts = (parseFloat(this.totalProducts) + (parseFloat(this.arrCart[i].inventory[j].amount)))
          }
        }
      },
      addToCart (inventory, store) {
        const vm = this
        const data = inventory
        const inventoryShop = {
          id: store.data.id,
          uid: store.data.uid,
          name: store.data.name,
          pictures: store.data.img,
          inventory: {
            id: inventory.id,
            data,
          },
          context: 'order',
          addressInfo: {
            addressgoogle: store.data.addressgoogle,
            lat: store.data.location.lat,
            lng: store.data.location.lng,
          },
        }
        // console.log(inventoryShop)
        vm.$store.dispatch('pos/addToCart', inventoryShop).then(() => {
          // console.log(vm.$store.getters['pos/getCart'])
          vm.getDataCart()
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
 .card-products{
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    flex-wrap: wrap;
    // min-height: 290px;
    max-height: 191px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 5px;
    position: relative;
    align-content: flex-start;
  }
  .divider {
    border-right: 2px solid #edeeee;
  }
  .store-list{
    background-color: #fff;
  }
  .store-card{
    max-height: 100px;
    min-width: 280px;
    width: 100%;
    max-width: 350px;
    margin: 10px;
    &__image{
      width: 120px;
      height: 80px;
      margin: auto 0;
      overflow: hidden;
      border-radius: 12px;
      img{
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
    &__container{
      display: flex;
      justify-content: flex-start;
      align-self: center;
    }
  }

  .product-card{
    transition: .3s;
    display: flex;
    flex-direction:column;
    height: 100%;
    min-height: 160px;
    max-height: 160px;
    max-width: 125px;
    min-width: 125px;
    border-radius: 16px !important;
    box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.3) !important;
    position: relative;
    overflow: hidden;
    &__tag {
      line-height: 15px;
      border-bottom: 1px dotted rgba(#000, 0.4);
      padding: 5px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      position: relative;
      z-index: 0;
      min-height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before, &:after {
        position: absolute;
        content: '';
        width: 8px;
        height: 8px;
        background: #d2d3d5;
        bottom: -4px;
        border-radius: 50%;
        z-index: 1;

      }
      &:before {
        left: -4px;
      }
      &:after {
        right: -4px;
      }
    }
    &__container{
      padding-bottom: 35px;
      max-height: 75vh;
      overflow-y: auto;
      @media(min-width: 768px){
        height: 100%;
        overflow: auto;
      }
    }
    &__content{
      padding: 10px;
     //
    }
    &__background{
      max-height: 70px;
      width: 100px;
      margin: auto;
      overflow: hidden;
      border-radius: 12px;
     //
    }
    &__money-tag{
      font-size: 1em;
      font-weight: bold;
      &__sign{
        color: #01b9c0;
        margin-right: 5px;
      }
    }
    &__addBtn{
      display: flex;
      justify-content: flex-end;
      margin-top: auto;
      width: 30px;
      position: absolute;
      right: 0;
      bottom: 0;
      transition: all 0.3s;
      &:hover{
        cursor:pointer;
        transform: scale(1.2);

      }

      &-container{
        width: 100px;
        height: 85px;
        margin-right: -35px;
        margin-bottom: -35px;
        background: #00b9c0;
        color: #ffF;
        border-radius: 50%;
        font-size: 30px;
        font-weight: 800;
        padding-left: 13px;
        display: flex;
        flex-direction: column;
        span{
          font-size: 35px;
          margin-top: 5px;
          margin-left: 0px;
        }
      }
    }
  }
</style>
